export enum ResultSeverity {
    Minor = 1,  //Blue
    Moderate = 2, //Yellow
    Major = 3, //Red
    Success = 4, //Teal
    MissingInfo = 5 //Gray
}
